export const environment = {
  production: true,
  apiUrl: '/cbm-server',
  geoserverUrl: '/geoserver',
  tileServerRoot: 'https://maps.ndw.nu/api/v1/osm/latest/png',
  recordIdFeatureEnabled: true,
  authConfigIssuer: 'https://iam.ndw.nu/auth/realms/ndw/protocol/openid-connect/auth',
  authTokenIssuer: 'https://iam.ndw.nu/auth/realms/ndw/protocol/openid-connect/token',
  authTokenLogout: 'https://iam.ndw.nu/auth/realms/ndw/protocol/openid-connect/logout',
  authConfigRedirectUri: '/keycloak-login-callback',
  authConfigCodeChallengeMethod: 'S256',
  authConfigClientId: 'app-nls-cbm-frontend-production',
  authConfigResponseType: 'code',
  authConfigScope: 'profile email openid',
  authInactivityIntervalInSeconds: 60,
  fcdSegmentsIngressApiKey: 'f8b6b695-2cad-44e8-b7e8-a97f9fc1c236'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts